<template>
  <div class="full-page">
    <img class="page-bg" src="@/assets/login/login-bg.png" alt="" />
    <div class="logo">
      <img src="@/assets/public/logo-text.png" alt="" />
    </div>
    <div class="black_box flex flex-col items-center justify-center">
      <div class="title">Si eres consumidor final visita:</div>
      <div class="flex items-center">
        <span class="tips">www.calabazapets.co</span>
        <img class="w-30px h-30px ml-14px" src="../../assets/click.png" alt="">
      </div>
    </div>
    <div class="login-container mt-36px">
      <div class="title-bar">Iniciar sesión</div>
      <div class="form">
        <div>
          <img src="@/assets/login/user.png" alt="" />
        </div>
        <div class="form-input">
          <input
            v-model="query.loginName"
            type="text"
            placeholder="+57 Por favor ingrese su contraseña"
          />
        </div>
      </div>
      <div class="form">
        <div>
          <img src="@/assets/login/psd.png" alt="" />
        </div>
        <div class="form-input">
          <input
            v-model="query.loginPwd"
            type="password"
            placeholder="Por favor ingrese su contraseña"
          />
        </div>
      </div>
      <div class="toOther">
        <div>
          <el-button type="text" @click="$router.push('/register')">
            Registrarse
          </el-button>
        </div>
        <div>
          <el-button type="text" @click="$router.push('/reset')">
            Olvidé mi contraseña
          </el-button>
        </div>
      </div>
      <div class="submit">
        <el-button
          type="success"
          style="width: 400px; height: 56px; border-radius: 28px"
          :disabled="!active"
          @click="login"
        >
          Iniciar sesión
        </el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="1200px"
      @close="closeDialog"
    >
      <register-info :editQuery="editQuery"></register-info>
    </el-dialog>
  </div>
</template>

<script>
import registerInfo from './register-info'
export default {
  components: {
    registerInfo
  },

  data() {
    return {
      checkIf: false,
      active: false,
      query: {
        loginName: '',
        loginPwd: ''
      },

      dialogVisible: false,
      editQuery: ''
    }
  },

  watch: {
    query: {
      handler() {
        this.judgeActive()
      },
      deep: true
    }
    // checkIf () { this.judgeActive() }
  },

  methods: {
    login() {
      this.axios.post('/member/auth/login', this.query).then((res) => {
        console.log(res)
        let data = res.data.result

        // 在这存储token是因为遇到要修改注册信息的用户提交时需要拿token，但为了防止下次打开进入首页，在main.js中对用户状态进行判断来控制登录行为
        this.$store.commit('SET_TOKEN', data.token)
        this.$store.commit('SET_INFO', data.memberDetail)

        let accountStatus = data.memberDetail.registrationStatus

        if (accountStatus !== 2) {
          if (accountStatus === 1) {
            this.$message(
              'La cuenta aún está bajo verificación, por favor espere pacientemente'
            ) //该账号还在审核中，请耐心等待
            return
          } else if (accountStatus === 3) {
            this.$message(
              'La cuenta no ha sido verificada , Por favor complete la información de nuevo y envíela para su verificación'
            ) //该账号审核未通过，请重新完善信息后再提交审核
            console.log('登录页跳转')
            setTimeout(() => {
              this.editQuery = data.memberDetail
              this.dialogVisible = true
            }, 3000)

            return
          }

          return
        }

        // this.$store.commit('SET_TOKEN', data.token)
        // this.$store.commit('SET_INFO', data.memberDetail)

        this.$router.push('/')
      })
    },

    judgeActive() {
      if (this.query.loginName !== '' && this.query.loginPwd !== '') {
        this.active = true
      } else {
        this.active = false
      }
    },

    closeDialog() {
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.full-page {
  position: relative;
  .page-bg {
    display: block;
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }

  .logo {
    width: 272px;
    position: absolute;
    top: 30px;
    left: 120px;
    img {
      width: 100%;
    }
  }
  .black_box {
    position: absolute;
    width: 510px;
    height: 106px;
    background: #1e2618;

    top: 150px;
    transform: translateY(-62%);
    right: 360px;
    .title {
      height: 34px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 34px;
    }
    .tips {
      height: 34px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #65b602;
      line-height: 34px;
      cursor: pointer;
    }
  }

  .login-container {
    position: absolute;
    top: 50%;
    right: 360px;
    transform: translateY(-62%);
    padding: 40px 55px;

    .title-bar {
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .form {
      display: flex;
      width: 400px;
      height: 56px;
      align-items: center;
      border-bottom: 1px solid #e7e7e7;
      margin-top: 20px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 20px;
      }
      .form-input {
        flex: 1;
        height: 100%;
        input {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #cccccc;
        }
      }
    }

    .toOther {
      display: flex;
      justify-content: space-between;
    }

    .submit {
      margin-top: 40px;
    }
  }
}
</style>
